import type { StaticDataRouteOption } from "@tanstack/react-router";

import { redirectToLogin, type UnauthorizedHandler } from "@/shared/api";

type MatchedRoute = { staticData: StaticDataRouteOption };

// Роутер приложения или тестовый: нужны только найденные маршруты текущего адреса.
type RouterWithMatches = {
  state: { matches: readonly MatchedRoute[]; pendingMatches?: readonly MatchedRoute[] };
};

// Реакция на 401 с учётом страницы. На страницах без входа (`staticData.isPublic`: политика,
// тарифы, оферта) 401 — обычное дело: переключатель языка в шапке спрашивает `GET /api/me`,
// а гость получает 401. Там никуда не уводим, иначе гость не увидит страницу. На остальных —
// полный переход на `/login?next=…` из `shared/api`.
export const createUnauthorizedHandler =
  (appRouter: RouterWithMatches, redirect: () => void = redirectToLogin): UnauthorizedHandler =>
  () => {
    const matches = appRouter.state.pendingMatches ?? appRouter.state.matches;
    if (matches.some((match) => match.staticData.isPublic === true)) {
      return;
    }
    redirect();
  };
